import httpClient from "@/_shared/http-client";
import { httpHelper, objectHelper } from "@/_shared/utils";

const handleCalendar = (httpMethod = 'post') => async (form) => {
  form = objectHelper.createCopy(form);
  form.dates = JSON.stringify(form.dates);
  form.times = JSON.stringify(form.times);
  form.users = form.users.map(({ id }) => id);
  form = httpHelper.addDateField(form, httpMethod);
  const url = `${process.env.BACKEND_URL}/shifts_calendar`;
  const response = await httpClient[httpMethod](url, form).catch(({ response }) => {
    throw new Error(response.data.message)
  });
  return response;
};

const get = async (id = 1) => {
  const url = new URL('/shifts_calendar', process.env.BACKEND_URL);
  url.searchParams.set('calendar_id', id);
  let results = {};
  await httpClient.get(url)
    .then(({ data }) => {
      const { record } = data;
      results = record;
    })
    .catch((error) => {
      throw new Error(error.message);
    });
  return results;
};

export const shiftsCalendarService = {
  get,
  add: handleCalendar('post'),
  edit: handleCalendar('patch'),
};



// WEBPACK FOOTER //
// ./src/user/api-services/shiftsCalendarService.js